import request from '@/utils/request'

/**
 * POST 方法 与 GET方法  区别
 *
 * post==> data: obj
 * get==>params: obj
 *
 */
 export function chaijieDetail(obj:any) {
  return request({
    url: '/report/reportInfo',
    method: 'get',
    params: obj,    
  })
} 
export function levelRank(obj:any) {
  return request({
    url: '/app/report/ranking',
    method: 'get',
    params: obj,    
  })
}
export function getCommenData(obj:any) {
  return request({
    url: '/report/itemList',
    method: 'get',
    params: obj,    
  })
}
export function getVideoData(obj:any) {
  return request({
    url: '/getMcnNewsListApi',      
    method: 'post',
    data: obj,    
  })
}
export function getcjxjData(obj:any) {
  return request({
    url: '/getCarParameterCategoryList',
    method: 'get',
    params: obj,    
  })
}
export function getFlashData(obj:any) {
  return request({
    url: '/app/getRecommendCar',      
    method: 'get',
    params: obj,    
  })
}

export function getCityList(obj: any) {
  return request({
    url: '/getCityListGroupByLetter',
    method: 'get',
    params: obj,
  })
}
export function getRate(obj: any) {
  return request({
    url: '/report/reportVote',
    method: 'get',
    params: obj,
  })
}

export function getRateTF(obj: any) {
  return request({
    url: '/report/reportInfo',
    method: 'get',
    params: obj,
  })
}
export function getCity(obj: any) {
  return request({
    url: '/region/getCityAndProvinceByCityName',
    method: 'get',
    params: obj,
  })
}